var formatter = new Intl.NumberFormat('en-US')

export default function (amount) {
  if (amount === undefined) { 
    return "N/A"
  }
  
  return formatter.format(amount)
}